"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_csv_1 = require("react-csv");
var DateRangePicker = function (_a) {
    var onExportCSV = _a.onExportCSV, csvHeaders = _a.csvHeaders, filename = _a.filename;
    var _b = (0, react_1.useState)(""), fromDate = _b[0], setFromDate = _b[1];
    var _c = (0, react_1.useState)(""), toDate = _c[0], setToDate = _c[1];
    var _d = (0, react_1.useState)(""), csvData = _d[0], setCSVdata = _d[1];
    var ref = (0, react_1.useRef)();
    var handleExportCSV = function () { return __awaiter(void 0, void 0, void 0, function () {
        var csvReport;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onExportCSV({ fromDate: fromDate, toDate: toDate })];
                case 1:
                    csvReport = _a.sent();
                    setCSVdata(csvReport);
                    return [2 /*return*/];
            }
        });
    }); };
    //https://github.com/react-csv/react-csv/issues/350
    (0, react_1.useEffect)(function () {
        if (csvData.length > 0 && ref.current) {
            ref.current.link.click();
        }
    }, [csvData]);
    return ((0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ className: "flex gap-2 w-auto relative" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.DatePickerControl, { label: "From Date", errorText: "", errorTextColor: "text-red-400", backgroundColor: "bg-gray", borderColor: "border-transaparent", value: fromDate, onChange: function (date) {
                    setFromDate(doshx_controls_web_1.Utilities.formatDateTime(date, "YYYY-MM-DD"));
                }, size: "small" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.DatePickerControl, { label: "To Date", errorText: "", errorTextColor: "text-red-400", backgroundColor: "bg-gray", borderColor: "border-transaparent", value: toDate, onChange: function (date) {
                    setToDate(doshx_controls_web_1.Utilities.formatDateTime(date, "YYYY-MM-DD"));
                }, size: "small" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "text-blue-500 m-2" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "hidden" }, { children: (0, jsx_runtime_1.jsxs)(react_csv_1.CSVLink, __assign({ ref: ref, data: csvData, filename: filename }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowDown }), " Export CSV"] })) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LinkButtonControl, { label: "Export CSV", textColor: "text-primary", onClick: handleExportCSV })] }))] })));
};
exports.DateRangePicker = DateRangePicker;
